var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardShell',[_c('BackLinkHeading',{attrs:{"linkText":"Inbox","text":"Enter Your Payment Info","sizeDependent":false,"route":"/inbox"}}),_c('PaymentDetails')],1)}
var staticRenderFns = []

export { render, staticRenderFns }